module.exports = __webpack_public_path__ + "static/media/servImg4.42cdd7e3.svg";